"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpExtended = exports.HttpUnofficial = exports.Http = void 0;
var helpers_1 = require("./helpers");
var Http;
(function (Http) {
    Http[Http["Continue"] = 100] = "Continue";
    Http[Http["SwitchingProtocols"] = 101] = "SwitchingProtocols";
    Http[Http["Processing"] = 102] = "Processing";
    Http[Http["EarlyHints"] = 103] = "EarlyHints";
    Http[Http["Ok"] = 200] = "Ok";
    Http[Http["Created"] = 201] = "Created";
    Http[Http["Accepted"] = 202] = "Accepted";
    Http[Http["NonAuthoritativeInformation"] = 203] = "NonAuthoritativeInformation";
    Http[Http["NoContent"] = 204] = "NoContent";
    Http[Http["ResetContent"] = 205] = "ResetContent";
    Http[Http["PartialContent"] = 206] = "PartialContent";
    Http[Http["MultiStatus"] = 207] = "MultiStatus";
    Http[Http["AlreadyReported"] = 208] = "AlreadyReported";
    Http[Http["ImUsed"] = 226] = "ImUsed";
    Http[Http["MultipleChoices"] = 300] = "MultipleChoices";
    Http[Http["MovedPermanently"] = 301] = "MovedPermanently";
    Http[Http["Found"] = 302] = "Found";
    Http[Http["SeeOther"] = 303] = "SeeOther";
    Http[Http["NotModified"] = 304] = "NotModified";
    Http[Http["UseProxy"] = 305] = "UseProxy";
    Http[Http["Unused"] = 306] = "Unused";
    Http[Http["TemporaryRedirect"] = 307] = "TemporaryRedirect";
    Http[Http["PermanentRedirect"] = 308] = "PermanentRedirect";
    Http[Http["BadRequest"] = 400] = "BadRequest";
    Http[Http["Unauthorized"] = 401] = "Unauthorized";
    Http[Http["PaymentRequired"] = 402] = "PaymentRequired";
    Http[Http["Forbidden"] = 403] = "Forbidden";
    Http[Http["NotFound"] = 404] = "NotFound";
    Http[Http["MethodNotAllowed"] = 405] = "MethodNotAllowed";
    Http[Http["NotAcceptable"] = 406] = "NotAcceptable";
    Http[Http["ProxyAuthenticationRequired"] = 407] = "ProxyAuthenticationRequired";
    Http[Http["RequestTimeout"] = 408] = "RequestTimeout";
    Http[Http["Conflict"] = 409] = "Conflict";
    Http[Http["Gone"] = 410] = "Gone";
    Http[Http["LengthRequired"] = 411] = "LengthRequired";
    Http[Http["PreconditionFailed"] = 412] = "PreconditionFailed";
    Http[Http["PayloadTooLarge"] = 413] = "PayloadTooLarge";
    Http[Http["UriTooLong"] = 414] = "UriTooLong";
    Http[Http["UnsupportedMediaType"] = 415] = "UnsupportedMediaType";
    Http[Http["RangeNotSatisfiable"] = 416] = "RangeNotSatisfiable";
    Http[Http["ExpectationFailed"] = 417] = "ExpectationFailed";
    Http[Http["ImATeapot"] = 418] = "ImATeapot";
    Http[Http["MisdirectedRequest"] = 421] = "MisdirectedRequest";
    Http[Http["UnprocessableEntity"] = 422] = "UnprocessableEntity";
    Http[Http["Locked"] = 423] = "Locked";
    Http[Http["FailedDependency"] = 424] = "FailedDependency";
    Http[Http["UpgradeRequired"] = 426] = "UpgradeRequired";
    Http[Http["PreconditionRequired"] = 428] = "PreconditionRequired";
    Http[Http["TooManyRequests"] = 429] = "TooManyRequests";
    Http[Http["RequestHeaderFieldsTooLarge"] = 431] = "RequestHeaderFieldsTooLarge";
    Http[Http["UnavailableForLegalReasons"] = 451] = "UnavailableForLegalReasons";
    Http[Http["InternalServerError"] = 500] = "InternalServerError";
    Http[Http["NotImplemented"] = 501] = "NotImplemented";
    Http[Http["BadGateway"] = 502] = "BadGateway";
    Http[Http["ServiceUnavailable"] = 503] = "ServiceUnavailable";
    Http[Http["GatewayTimeout"] = 504] = "GatewayTimeout";
    Http[Http["HttpVersionNotSupported"] = 505] = "HttpVersionNotSupported";
    Http[Http["VariantAlsoNegotiates"] = 506] = "VariantAlsoNegotiates";
    Http[Http["InsufficientStorage"] = 507] = "InsufficientStorage";
    Http[Http["LoopDetected"] = 508] = "LoopDetected";
    Http[Http["NotExtended"] = 510] = "NotExtended";
    Http[Http["NetworkAuthenticationRequired"] = 511] = "NetworkAuthenticationRequired";
})(Http = exports.Http || (exports.Http = {}));
var HttpUnofficial;
(function (HttpUnofficial) {
    HttpUnofficial[HttpUnofficial["Checkpoint"] = 103] = "Checkpoint";
    HttpUnofficial[HttpUnofficial["ThisIsFine"] = 218] = "ThisIsFine";
    HttpUnofficial[HttpUnofficial["EnhanceYourCalm"] = 420] = "EnhanceYourCalm";
    HttpUnofficial[HttpUnofficial["BlockedByWindowsParentalControls"] = 450] = "BlockedByWindowsParentalControls";
    HttpUnofficial[HttpUnofficial["InvalidToken"] = 498] = "InvalidToken";
    HttpUnofficial[HttpUnofficial["TokenRequired"] = 499] = "TokenRequired";
    HttpUnofficial[HttpUnofficial["BandwidthLimitExceeded"] = 509] = "BandwidthLimitExceeded";
    HttpUnofficial[HttpUnofficial["SiteIsFrozen"] = 530] = "SiteIsFrozen";
    HttpUnofficial[HttpUnofficial["NetworkReadTimeoutError"] = 598] = "NetworkReadTimeoutError";
})(HttpUnofficial = exports.HttpUnofficial || (exports.HttpUnofficial = {}));
exports.HttpExtended = helpers_1.mergeEnums(Http, HttpUnofficial);
//# sourceMappingURL=http.js.map